import { useState, useEffect, createContext, useContext } from 'react';
import { contentAPI } from '../lib/api';

const UITextContext = createContext({});

export function UITextProvider({ children }) {
  const [texts, setTexts] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    contentAPI.getPublicUITexts('en')
      .then(res => setTexts(res.data || {}))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <UITextContext.Provider value={{ texts, loaded }}>
      {children}
    </UITextContext.Provider>
  );
}

export function useUIText() {
  const { texts, loaded } = useContext(UITextContext);
  const t = (key, fallback) => texts[key] || fallback || key;
  return { t, loaded };
}
